'use client';
import { useState, useEffect, useRef, useMemo, useCallback } from 'react';
import React from 'react';
import {
   Box,
   Flex,
   Table,
   Tbody,
   Td,
   Text,
   Tr,
   useColorModeValue,
   useDisclosure,
   Checkbox,
   Drawer,
   DrawerOverlay,
   DrawerContent,
   DrawerCloseButton,
   DrawerHeader,
   DrawerBody,
   useOutsideClick,
   Spinner,
} from '@chakra-ui/react';
import Select from 'react-select';
import 'jspdf-autotable';
import Card from 'components/card/Card';
import { GridItem, Input } from '@chakra-ui/react';
import nodata from 'assets/img/nfts/no data.svg';
import {
   Button,
   Modal,
   ModalOverlay,
   ModalContent,
   ModalHeader,
   ModalFooter,
   ModalBody,
   ModalCloseButton,
   Image,
   Thead,
   Th,
   Grid,
   IconButton,
} from '@chakra-ui/react';
import Download from '../../../../assets/img/nfts/download.svg';
import xls from '../../../../../src/assets/img/nfts/xls.svg';
import back from '../../../../../src/assets/img/nfts/back.svg';
import { Popover, PopoverTrigger, PopoverContent, PopoverBody } from '@chakra-ui/react';
import { useDispatch, useSelector } from 'react-redux';
import cancel from '../../../../assets/img/nfts/cancel.svg';
import StatementFilter from '../components/StatementFilter';
import { IoFilterOutline } from 'react-icons/io5';
import { getTrialBalance, getTrialBalanceGLGroupWise, getTrialBalanceFull } from '../../../../redux/actions/reports';
import {
   createColumnHelper,
   flexRender,
   getCoreRowModel,
   getSortedRowModel,
   useReactTable,
} from '@tanstack/react-table';
import { SearchIcon } from '@chakra-ui/icons';
import { getShareCompanyOptions } from 'utils/util';
import DotIcon from '../../../../assets/img/nfts/dot.svg';
import { REPORT_TYPE } from 'constants';
import { renderDynamicDropdown } from '../../../../components/ui/DynamicDropdown';
import { jsPDF } from 'jspdf';
import * as XLSX from 'xlsx-js-style';
import { motion } from 'framer-motion';
import { LuRefreshCcw } from 'react-icons/lu';
import PeriodDatePicker from 'components/RangePicker/PeriodDatePicker';
import { useGlobal } from 'contexts';
import Loader from 'views/admin/default/Loader';
const MotionFlex = motion(Flex);
const MotionSearchIcon = motion(SearchIcon);

// Define Trial Balance specific columns
const trialBalanceColumns = [
   {
      id: 'accountName',
      header: 'Account',
      accessorKey: 'accountName',
   },
   {
      id: 'OpeningAmount',
      header: 'Opening Balance',
      accessorKey: 'OpeningAmount',
   },
   {
      id: 'debitAmount',
      header: 'Total-Debits',
      accessorKey: 'debitAmount',
   },
   {
      id: 'creditAmount',
      header: 'Total-Credits',
      accessorKey: 'creditAmount',
   },
   {
      id: 'closingAmount',
      header: 'Closing Balance',
      accessorKey: 'closingAmount',
   },
];

const TrialBalance = () => {
   const columnHelper = createColumnHelper();
   const textColor = useColorModeValue('secondaryGray.900', 'white');
   const backgroundColor = useColorModeValue('white', '#101F4A');
   const borderColor = useColorModeValue('gray.200', 'whiteAlpha.100');
   const controlBg = useColorModeValue('#FFFFFF', '#2D3748');
   const controlBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const controlBorderHover = useColorModeValue('#CBD5E0', '#718096');
   const focusBoxShadow = useColorModeValue('0 0 0 1px #3182CE', '0 0 0 1px #63B3ED');
   const placeholderColor = useColorModeValue('#A0AEC0', '#718096');
   const optionBg = useColorModeValue('#FFFFFF', '#2D3748');
   const optionHoverBg = useColorModeValue('#EDF2F7', '#4A5568');
   const menuBg = useColorModeValue('#FFFFFF', '#2D3748');
   const menuBorder = useColorModeValue('#E2E8F0', '#4A5568');
   const indicatorColor = useColorModeValue('#718096', '#A0AEC0');
   const indicatorHoverColor = useColorModeValue('#4A5568', '#CBD5E0');
   const company = useSelector((state) => state.company.list || []);
   const [fromDate, setFromDate] = useState(null);
   const [toDate, setToDate] = useState(new Date().toISOString().split('T')[0]);
   const [companyFilter, setCompanyFilter] = useState([]);
   const [reportType, setReportType] = useState('Trail Balance Account');
   const [expandedItems, setExpandedItems] = useState({});
   const [sorting, setSorting] = useState([]);
   const [columnVisibility, setColumnVisibility] = useState({});
   const [isColumnSelectorOpen, setIsColumnSelectorOpen] = useState(false);
   const dbName = localStorage.getItem('dbName');
   const salesReport = useSelector((state) => state.reports?.trialBalanceFull || []);
   const trialBalanceFullGlGroup = useSelector((state) => state.reports?.trialBalanceGlGroupWise || []);
   const trialBalance = useSelector((state) => state.reports?.trialBalance || []);
   const [searchQuery, setSearchQuery] = useState('');
   const [isSearchLoading, setIsSearchLoading] = useState(false);
   const [debouncedSearchQuery, setDebouncedSearchQuery] = useState('');
   const bg = useColorModeValue('#f2f7f2', '#1a254b');
   const icon = useColorModeValue('#000000', '#ffffff');
   const searchTimeoutRef = useRef(null);
   const [datePartyWiseSalesRange, setPartyWiseSalesDateRange] = useState('');
   const [dateRange, setDateRange] = useState(() => {
      const today = new Date();
      const sevenDaysAgo = new Date();
      sevenDaysAgo.setDate(today.getDate() - 6);

      return {
         fromDate: sevenDaysAgo.toISOString().split('T')[0], // last 7th day
         toDate: today.toISOString().split('T')[0], // today
      };
   });
   const [isLoading, setIsLoading] = useState(false);

   // FIXED: Add loading states to track data fetching
   const [isDataLoaded, setIsDataLoaded] = useState(false);
   const [hasInitialLoad, setHasInitialLoad] = useState(false);
   const { companyList } = useGlobal();
   const { isOpen: isFilterOpen, onOpen: onFilterOpen, onClose: onFilterClose } = useDisclosure();

   const reportTypeOptions = [
      { value: 'Trail Balance Account', label: 'Trail Balance Account' },
      { value: 'Trail Balance T Format', label: ' Trail Balance T Format' },
      { value: 'Trail Balance Vertical', label: 'Trail Balance Vertical' },
      { value: 'Trail Balance GL Group', label: 'Trail Balance GL Group' },
   ];

   const handleCompanyChange = (selectedOptions) => {
      setCompanyFilter(selectedOptions ? selectedOptions : []);
   };

   const dispatch = useDispatch();
   const fromDateInputRef = useRef(null);

   // Initialize dates
   useEffect(() => {
      if (!fromDate) {
         const today = new Date();
         today.setFullYear(today.getFullYear() - 1);
         const formattedDate = today.toISOString().split('T')[0];
         setFromDate(formattedDate);
      }
   }, [fromDate]);

   // Initialize column visibility for Trial Balance columns
   useEffect(() => {
      const initialColumnVisibility = {};
      trialBalanceColumns.forEach((column) => {
         initialColumnVisibility[column.id] = true;
      });
      setColumnVisibility(initialColumnVisibility);
   }, []);

   // Create columns using Trial Balance specific columns
   const columns = useMemo(() => {
      return trialBalanceColumns.map((column) =>
         columnHelper.accessor(column.accessorKey, {
            id: column.id,
            header: () => (
               <Text
                  justifyContent="space-between"
                  align="center"
                  fontSize={{ sm: '10px', lg: '12px' }}
                  color={textColor}>
                  {column.header}
               </Text>
            ),
            cell: (info) => {
               const value = info.getValue();
               // Format currency values
               if (['OpeningAmount', 'debitAmount', 'debitAmount', 'closingAmount'].includes(column.id)) {
                  if (value === null || value === undefined) {
                     return <Flex align="center">-</Flex>;
                  }
                  const numValue = Number(value);
                  if (isNaN(numValue)) {
                     return <Flex align="center">{value}</Flex>;
                  }
                  return (
                     <Flex align="center" justifyContent="flex-end">
                        ₹{numValue.toLocaleString()}
                     </Flex>
                  );
               }
               return <Flex align="center">{value}</Flex>;
            },
         }),
      );
   }, [columnHelper, textColor]);
   const { isOpen, onOpen, onClose } = useDisclosure();

   // React Table Instance
   const table = useReactTable({
      data: salesReport,
      columns,
      state: {
         sorting,
         columnVisibility,
      },
      onSortingChange: setSorting,
      onColumnVisibilityChange: setColumnVisibility,
      getCoreRowModel: getCoreRowModel(),
      getSortedRowModel: getSortedRowModel(),
   });

   const companyOptions = useMemo(() => {
      return getShareCompanyOptions({ dbName, company: companyList });
   }, [companyList, dbName]);

   // FIXED: Initialize company filter with improved logic
   useEffect(() => {
      if (companyList.length > 0 && companyFilter.length === 0) {
         const storedCompanyId = localStorage.getItem('companyId');
         if (storedCompanyId) {
            const companyIdNum = parseInt(storedCompanyId, 10);
            if (!isNaN(companyIdNum)) {
               const matchingCompany = companyList.find((comp) => comp.id === companyIdNum);
               if (matchingCompany) {
                  setCompanyFilter([companyIdNum]);
               }
            }
         }
      }
   }, [companyList, companyFilter]);

   const lastcompanyOptions = companyOptions.map((company) => ({
      value: company.value,
      label: company.label,
      id: company.value,
      name: company.label,
   }));

   // FIXED: Improved API call logic with proper dependency management
   const fetchTrialBalanceData = useCallback(
      async (companyIds, reportType, fromDate, toDate, datePartyWiseSalesRange) => {
         if (
            !companyIds ||
            companyIds.length === 0 ||
            !datePartyWiseSalesRange?.fromDate ||
            !datePartyWiseSalesRange?.toDate
         ) {
            return;
         }

         const companyIdsString = companyIds.join(',');
         setIsLoading(true);
         setIsDataLoaded(false);

         try {
            if (reportType === 'Trail Balance GL Group') {
               await dispatch(
                  getTrialBalanceGLGroupWise({
                     companyIds: companyIdsString,
                     fromDate: datePartyWiseSalesRange.fromDate,
                     toDate: datePartyWiseSalesRange.toDate,
                     search: debouncedSearchQuery,
                  }),
               );
            } else if (reportType === 'Trail Balance T Format') {
               await dispatch(
                  getTrialBalanceFull({
                     companyIds: companyIdsString,
                     fromDate: datePartyWiseSalesRange.fromDate,
                     toDate: datePartyWiseSalesRange.toDate,
                     search: debouncedSearchQuery,
                  }),
               );
            } else {
               await dispatch(
                  getTrialBalance({
                     companyIds: companyIdsString,
                     fromDate: datePartyWiseSalesRange.fromDate,
                     toDate: datePartyWiseSalesRange.toDate,
                     search: debouncedSearchQuery,
                  }),
               );
            }
         } catch (error) {
            console.error('Error fetching trial balance data:', error);
            // Handle error appropriately
         } finally {
            setIsDataLoaded(true);
            setHasInitialLoad(true);
            setIsLoading(false);
         }
      },
      [dispatch, debouncedSearchQuery],
   );

   const handleDateRangeChange = (dates) => {
      if (!dates || dates.length !== 2) return;

      const [from, to] = dates.map((date) => (typeof date === 'string' ? date : date.toISOString().slice(0, 10)));

      setPartyWiseSalesDateRange({ fromDate: from, toDate: to });
   };

   const handleSearchChange = (e) => {
      const value = e.target.value;
      setSearchQuery(value); // Update UI immediately

      // Clear previous timeout
      if (searchTimeoutRef.current) {
         clearTimeout(searchTimeoutRef.current);
      }

      // Set new timeout (500ms after typing stops)
      searchTimeoutRef.current = setTimeout(() => {
         performSearch(value);
      }, 500);
   };
   useEffect(() => {
      const handler = setTimeout(() => {
         setDebouncedSearchQuery(searchQuery);
      }, 500);

      return () => {
         clearTimeout(handler);
      };
   }, [searchQuery]);

   const [expanded, setExpanded] = useState(false);
   const wrapperRef = useRef();
   useOutsideClick({
      ref: wrapperRef,
      handler: () => {
         if (searchQuery === '') setExpanded(false);
      },
   });

   const performSearch = async () => {
      setIsSearchLoading(true);
      const search = searchQuery.trim();

      try {
         const companyIds =
            companyFilter.length > 0
               ? companyFilter
               : localStorage.getItem('companyId')
               ? [parseInt(localStorage.getItem('companyId'))]
               : [];

         const companyIdsString = companyIds.join(',');

         let dispatchAction;

         if (reportType === 'Trail Balance GL Group') {
            dispatchAction = getTrialBalanceGLGroupWise({
               companyIds: companyIdsString,
               fromDate,
               toDate,
               search, // This will be empty string when cleared
            });
         } else if (reportType === 'Trail Balance T Format') {
            dispatchAction = getTrialBalanceFull({
               companyIds: companyIdsString,
               fromDate,
               toDate,
               search,
            });
         } else {
            dispatchAction = getTrialBalance({
               companyIds: companyIdsString,
               fromDate,
               toDate,
               search,
            });
         }

         await dispatch(dispatchAction);
         setIsDataLoaded(true);
         setHasInitialLoad(true);
      } catch (error) {
         console.error('Search error:', error);
      } finally {
         setIsSearchLoading(false);
      }
   };

   const handleRefresh = () => {
      const companyIds =
         companyFilter.length > 0
            ? companyFilter
            : localStorage.getItem('companyId')
            ? [parseInt(localStorage.getItem('companyId'))]
            : [];

      const companyIdsString = companyIds.join(',');

      if (reportType === 'Trail Balance GL Group') {
         dispatch(
            getTrialBalanceGLGroupWise({
               companyIds: companyIdsString,
               fromDate: fromDate,
               toDate: toDate,
               search: debouncedSearchQuery,
            }),
         ).finally(() => {
            setIsDataLoaded(true);
            setHasInitialLoad(true);
         });
      } else if (reportType === 'Trail Balance T Format') {
         dispatch(
            getTrialBalanceFull({
               companyIds: companyIdsString,
               fromDate: fromDate,
               toDate: toDate,
               search: debouncedSearchQuery,
            }),
         ).finally(() => {
            setIsDataLoaded(true);
            setHasInitialLoad(true);
         });
      } else {
         dispatch(
            getTrialBalance({
               companyIds: companyIdsString,
               fromDate: fromDate,
               toDate: toDate,
               search: debouncedSearchQuery,
            }),
         ).finally(() => {
            setIsDataLoaded(true);
            setHasInitialLoad(true);
         });
      }
   };

   useEffect(() => {
      return () => {
         if (searchTimeoutRef.current) {
            clearTimeout(searchTimeoutRef.current);
         }
      };
   }, []);

   // FIXED: Main effect for API calls with better timing control
   useEffect(() => {
      // Wait for all required data to be available
      if (!datePartyWiseSalesRange?.fromDate || !datePartyWiseSalesRange?.toDate) {
         return;
      }

      let companyIds = [];

      // Get company IDs from filter or localStorage
      if (companyFilter.length > 0) {
         companyIds = companyFilter.filter((id) => !isNaN(id) && id !== null && id !== undefined);
      } else if (company.length > 0) {
         // If no company filter but companies are loaded, try to get from localStorage
         const storedCompanyId = localStorage.getItem('companyId');
         if (storedCompanyId) {
            const parsedId = parseInt(storedCompanyId, 10);
            if (!isNaN(parsedId)) {
               companyIds = [parsedId];
               // Also update the filter state
               setCompanyFilter([parsedId]);
            }
         }
      }

      // Only make API calls if we have valid company IDs
      if (companyIds.length > 0) {
         fetchTrialBalanceData(companyIds, reportType, fromDate, toDate, datePartyWiseSalesRange);
      }
   }, [companyFilter, reportType, company, fetchTrialBalanceData, datePartyWiseSalesRange, fromDate, toDate]);

   // FIXED: Ensure initial load happens even if filters change
   useEffect(() => {
      // Force initial data load if we haven't loaded any data yet and all conditions are met
      if (!hasInitialLoad && fromDate && toDate && company.length > 0) {
         const storedCompanyId = localStorage.getItem('companyId');
         if (storedCompanyId) {
            const parsedId = parseInt(storedCompanyId, 10);
            if (!isNaN(parsedId)) {
               fetchTrialBalanceData([parsedId], reportType, fromDate, toDate);
            }
         }
      }
   }, [hasInitialLoad, fromDate, toDate, company, reportType, fetchTrialBalanceData]);

   useEffect(() => {
      if (salesReport && salesReport.length > 0 && reportType === REPORT_TYPE.party) {
         const initialExpandedState = {};
         salesReport.forEach((companyData) => {
            initialExpandedState[`company-${companyData.companyId}`] = true;
            if (companyData.data && Array.isArray(companyData.data)) {
               companyData.data.forEach((accountData) => {
                  initialExpandedState[`account-${accountData.accountId}`] = true;
               });
            }
         });
         setExpandedItems(initialExpandedState);
      }
   }, [salesReport, reportType]);

   useEffect(() => {
      const handleKeyDown = (e) => {
         const isTargetInput =
            e.target.tagName === 'INPUT' ||
            e.target.tagName === 'TEXTAREA' ||
            e.target.tagName === 'SELECT' ||
            e.target.isContentEditable;

         if (e.key.toLowerCase() === 't' && !isTargetInput) {
            if (fromDateInputRef.current) {
               fromDateInputRef.current.focus();
            }
         }
      };

      document.addEventListener('keydown', handleKeyDown);
      return () => {
         document.removeEventListener('keydown', handleKeyDown);
      };
   }, []);

   const downloadExcel = () => {
      if (reportType === 'Trail Balance Account') {
         const colors = {
            companyHeader: 'F8FAFC', // Light blue for company headers (matches UI)
            itemHeader: 'F8FAFC', // Light gray for item headers
            oddRow: 'FFFFFF', // White for odd rows
            evenRow: 'F5F5F5', // Light gray for even rows
            totalRow: 'E6FFED', // Light green for totals
            headerText: '000000', // Black for header text
         };

         const headers = ['Account', 'Opening Balance', 'Total-Debits', 'Total-Credits', 'Total-Credits'];
         const finalData = [];
         const styles = [];

         salesReport.forEach((salesReport) => {
            // finalData.push([`${salesReport.companyName}`]);
            const companyNameRow = Array(headers.length).fill('');
            companyNameRow[0] = salesReport.companyName;
            finalData.push(companyNameRow);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 14, color: { rgb: colors.headerText } },
                  fill: { patternType: 'solid', fgColor: { rgb: 'F8FAFC' } },
                  alignment: { horizontal: 'left' },
               }),
            );

            finalData.push(headers);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 12, color: { rgb: colors.headerText } },
               }),
            );

            salesReport.data.forEach((group) => {
               finalData.push([group.gname, '', '', '', 'Total Amount: ₹0']);
               styles.push(
                  Array(headers.length).fill({
                     font: { bold: true, sz: 10, color: { rgb: colors.headerText } },
                  }),
               );

               group.data.map((groupdata) => {
                  const row = [];
                  const rowStyle = [];
                  row.push(groupdata.gname || '');
                  row.push('');
                  row.push('');
                  row.push('');
                  row.push('Total Amount: ₹0');

                  finalData.push([
                     groupdata.accountName,
                     groupdata.OpeningAmount,
                     groupdata.debitAmount,
                     groupdata.creditAmount,
                     groupdata.closingAmount,
                  ]);
                  styles.push(rowStyle);
               });

               finalData.push([]);
               styles.push([]);
            });

            finalData.push([]);
            styles.push([]);
         });

         // Create worksheet and workbook
         const ws = XLSX.utils.aoa_to_sheet(finalData);

         // Set column widths
         ws['!cols'] = [{ width: 40 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }];

         // Apply styles to each cell
         styles.forEach((rowStyles, rowNum) => {
            rowStyles.forEach((style, colNum) => {
               if (style) {
                  const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                  if (!ws[cellAddress]) ws[cellAddress] = {};
                  ws[cellAddress].s = style;
               }
            });
         });

         const wb = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Trial Balance');
         XLSX.writeFile(wb, 'TrialBalance.xlsx');
      }

      if (reportType === 'Trail Balance GL Group') {
         const colors = {
            companyHeader: 'F8FAFC', // Light blue for company headers (matches UI)
            itemHeader: 'F8FAFC', // Light gray for item headers
            oddRow: 'FFFFFF', // White for odd rows
            evenRow: 'F5F5F5', // Light gray for even rows
            totalRow: 'E6FFED', // Light green for totals
            headerText: '000000', // Black for header text
         };

         const headers = ['Account', 'Opening Balance', 'Total-Debits', 'Total-Credits', 'Total-Credits'];
         const finalData = [];
         const styles = [];

         trialBalanceFullGlGroup.forEach((salesReport) => {
            // finalData.push([`${salesReport.companyName}`]);
            const companyNameRow = Array(headers.length).fill('');
            companyNameRow[0] = salesReport.companyName;
            finalData.push(companyNameRow);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 14, color: { rgb: colors.headerText } },
                  fill: { patternType: 'solid', fgColor: { rgb: 'F8FAFC' } },
                  alignment: { horizontal: 'left' },
               }),
            );

            finalData.push(headers);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 12, color: { rgb: colors.headerText } },
               }),
            );

            salesReport.data.map((group) => {
               finalData.push([
                  group.gname,
                  group.OpeningAmount || 0,
                  group.debitAmount || 0,
                  group.creditAmount || 0,
                  group.closingAmount || 0,
               ]);
               styles.push(
                  Array(headers.length).fill({
                     font: { sz: 10, color: { rgb: colors.headerText } },
                  }),
               );
            });

            finalData.push([]);
            styles.push([]);
         });

         // Create worksheet and workbook
         const ws = XLSX.utils.aoa_to_sheet(finalData);

         // Set column widths
         ws['!cols'] = [{ width: 40 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }];

         // Apply styles to each cell
         styles.forEach((rowStyles, rowNum) => {
            rowStyles.forEach((style, colNum) => {
               if (style) {
                  const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                  if (!ws[cellAddress]) ws[cellAddress] = {};
                  ws[cellAddress].s = style;
               }
            });
         });

         const wb = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Trial Balance');
         XLSX.writeFile(wb, 'TrialBalance.xlsx');
      }

      if (reportType === 'Trail Balance Vertical') {
         const groupedAccounts = {};

         // Process all account data from all companies
         trialBalance.forEach((company) => {
            if (company.data && Array.isArray(company.data)) {
               company.data.forEach((group) => {
                  // Each group contains an array of accounts in group.data
                  const groupName = group.gl_group_name || '-';

                  if (!groupedAccounts[groupName]) {
                     groupedAccounts[groupName] = {
                        accounts: [],
                        totalDebit: 0,
                        totalCredit: 0,
                        companyName: company.companyName,
                     };
                  }

                  // Add all accounts from this group
                  if (group.data && Array.isArray(group.data)) {
                     group.data.forEach((account) => {
                        groupedAccounts[groupName].accounts.push(account);
                     });
                  }
               });
            } else if (company.account_name) {
               // Handle direct account data (fallback)
               const groupName = company.gl_group_name || '-';

               if (!groupedAccounts[groupName]) {
                  groupedAccounts[groupName] = {
                     accounts: [],
                     totalDebit: 0,
                     totalCredit: 0,
                     companyName: company.companyName,
                  };
               }
               groupedAccounts[groupName].accounts.push(company);
            }
         });

         // Calculate group totals
         Object.keys(groupedAccounts).forEach((groupName) => {
            const group = groupedAccounts[groupName];
            group.totalDebit = group.accounts.reduce((sum, account) => {
               return sum + Number(account.debit_amount || 0);
            }, 0);
            group.totalCredit = group.accounts.reduce((sum, account) => {
               return sum + Number(account.credit_amount || 0);
            }, 0);
         });

         const colors = {
            companyHeader: 'F8FAFC', // Light blue for company headers (matches UI)
            itemHeader: 'F8FAFC', // Light gray for item headers
            oddRow: 'FFFFFF', // White for odd rows
            evenRow: 'F5F5F5', // Light gray for even rows
            totalRow: 'E6FFED', // Light green for totals
            headerText: '000000', // Black for header text
         };

         const headers = ['Account Code', 'Account', 'Credits', 'Debits'];
         const finalData = [];
         const styles = [];

         finalData.push(headers);
         styles.push(
            Array(headers.length).fill({
               font: { bold: true, sz: 12, color: { rgb: colors.headerText } },
            }),
         );

         Object.entries(groupedAccounts).forEach(([groupName, group]) => {
            // Push group name row
            finalData.push([groupName, '', group.totalCredit, group.totalDebit]);

            styles.push(
               Array(5).fill({
                  font: { bold: true, sz: 14, color: { rgb: colors.headerText } },
                  fill: { patternType: 'solid', fgColor: { rgb: 'F1F5F9' } },
               }),
            );

            group.accounts.map((subData) => {
               // Optional: Add headers for account rows
               finalData.push([
                  subData.account_group_code || '-',
                  subData.account_name,
                  subData.credit_amount || 0,
                  subData.debit_amount || 0,
               ]);
               styles.push(
                  Array(5).fill({
                     font: { sz: 12, color: { rgb: colors.headerText } },
                  }),
               );
            });

            // Optional: Add blank row for spacing
            finalData.push([]);
            styles.push([]);
         });

         // Create worksheet and workbook
         const ws = XLSX.utils.aoa_to_sheet(finalData);

         // Set column widths
         ws['!cols'] = [{ width: 40 }, { width: 20 }, { width: 20 }, { width: 20 }, { width: 20 }];

         // Apply styles to each cell
         styles.forEach((rowStyles, rowNum) => {
            rowStyles.forEach((style, colNum) => {
               if (style) {
                  const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                  if (!ws[cellAddress]) ws[cellAddress] = {};
                  ws[cellAddress].s = style;
               }
            });
         });

         const wb = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Trial Balance');
         XLSX.writeFile(wb, 'TrialBalance.xlsx');
      }

      if (reportType === 'Trail Balance T Format') {
         const allGLGroupData = [];
         trialBalance.forEach((group) => {
            if (group.data && Array.isArray(group.data)) {
               group.data.forEach((glGroup) => {
                  allGLGroupData.push(glGroup);
               });
            } else {
               allGLGroupData.push(group);
            }
         });

         // Separate credit and debit groups
         const creditGroups = [];
         const debitGroups = [];

         allGLGroupData.forEach((group) => {
            if (group.data && group.data.length > 0) {
               const totalCredit = group.data.reduce((sum, acc) => sum + (acc.credit_amount || 0), 0);
               const totalDebit = group.data.reduce((sum, acc) => sum + (acc.debit_amount || 0), 0);

               // Determine if group is primarily credit or debit based on totals
               if (totalCredit >= totalDebit) {
                  creditGroups.push(group);
               } else {
                  debitGroups.push(group);
               }
            }
         });

         // Calculate grand totals
         const grandTotalCredit = allGLGroupData.reduce(
            (sum, group) => sum + (group.data?.reduce((s, acc) => s + (acc.credit_amount || 0), 0) || 0),
            0,
         );
         const grandTotalDebit = allGLGroupData.reduce(
            (sum, group) => sum + (group.data?.reduce((s, acc) => s + (acc.debit_amount || 0), 0) || 0),
            0,
         );

         const finalAllData = [
            {
               debit: debitGroups,
               credit: creditGroups,
            },
         ];

         const colors = {
            companyHeader: 'F8FAFC', // Light blue for company headers (matches UI)
            itemHeader: 'F8FAFC', // Light gray for item headers
            oddRow: 'FFFFFF', // White for odd rows
            evenRow: 'F5F5F5', // Light gray for even rows
            totalRow: 'E6FFED', // Light green for totals
            headerText: '000000', // Black for header text
         };

         const headers = ['Account', 'Amount', '', 'Account', 'Amount'];
         const finalData = [];
         const styles = [];
         const maxRows = Math.max(creditGroups.length, debitGroups.length);

         finalAllData.forEach((salesReport) => {
            finalData.push(['Credits', '', '', 'Debits', '']);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 14, color: { rgb: colors.headerText } },
                  fill: { patternType: 'solid', fgColor: { rgb: 'F8FAFC' } },
                  alignment: { horizontal: 'left' },
               }),
            );

            finalData.push(headers);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 12, color: { rgb: colors.headerText } },
               }),
            );

            let count = 0;

            while (count < maxRows) {
               finalData.push([
                  salesReport?.credit?.[count]?.gl_group_name || '',
                  salesReport?.credit?.[count]?.credit_amount || '',
                  '',
                  salesReport?.debit?.[count]?.gl_group_name || '',
                  salesReport?.debit?.[count]?.credit_amount || '',
               ]);

               styles.push(
                  Array(headers.length).fill({
                     font: { bold: true, sz: 12, color: { rgb: colors.headerText } },
                  }),
               );

               const debitRows = salesReport.debit?.[count]?.data || [];
               const creditRows = salesReport.credit?.[count]?.data || [];

               const maxLength = Math.max(debitRows.length, creditRows.length);

               for (let i = 0; i < maxLength; i++) {
                  const db = debitRows[i] || {};
                  const cr = creditRows[i] || {};

                  finalData.push([
                     cr?.credit_amount !== 0 ? cr?.account_name : '',
                     cr?.credit_amount !== 0 ? cr?.credit_amount : '',
                     '',
                     db?.debit_amount !== 0 ? db?.account_name : '',
                     db?.debit_amount !== 0 ? db?.debit_amount : '',
                  ]);

                  styles.push(
                     Array(headers.length).fill({
                        font: { sz: 12, color: { rgb: colors.headerText } },
                     }),
                  );
               }

               finalData.push([]);
               styles.push([]);

               count++;
            }

            finalData.push(['Grand Total :', grandTotalCredit, '', 'Grand Total :', grandTotalDebit]);
            styles.push(
               Array(headers.length).fill({
                  font: { bold: true, sz: 14, color: { rgb: colors.headerText } },
                  fill: { patternType: 'solid', fgColor: { rgb: 'F8FAFC' } },
                  alignment: { horizontal: 'left' },
               }),
            );
         });

         // Create worksheet and workbook
         const ws = XLSX.utils.aoa_to_sheet(finalData);

         // Set column widths
         ws['!cols'] = [{ width: 40 }, { width: 20 }, { width: 5 }, { width: 40 }, { width: 20 }];

         // Apply styles to each cell
         styles.forEach((rowStyles, rowNum) => {
            rowStyles.forEach((style, colNum) => {
               if (style) {
                  const cellAddress = XLSX.utils.encode_cell({ r: rowNum, c: colNum });
                  if (!ws[cellAddress]) ws[cellAddress] = {};
                  ws[cellAddress].s = style;
               }
            });
         });

         const wb = XLSX.utils.book_new();
         XLSX.utils.book_append_sheet(wb, ws, 'Trial Balance');
         XLSX.writeFile(wb, 'TrialBalance.xlsx');
      }
   };

   const downloadPDF = () => {
      const doc = new jsPDF({
         orientation: 'landscape',
         unit: 'mm',
      });

      // Define colors matching your UI
      const colors = {
         companyHeader: [240, 235, 227], // #F0EBE3
         groupHeader: [232, 244, 253], // #E8F4FD
         glGroupHeader: [227, 242, 253], // #E3F2FD
         verticalGroupHeader: [227, 242, 253], // #E3F2FD
         tFormatCreditHeader: [241, 240, 232], // #F1F0E8
         tFormatDebitHeader: [158, 184, 217], // #9EB8D9
         alternateRow: [245, 245, 245], // #F5F5F5
         white: [255, 255, 255], // White
         headerText: [0, 0, 0], // Black
         normalText: [0, 0, 0], // Black
         tableHeader: [245, 245, 245], // #F5F5F5
      };

      // Title and date range
      doc.setFontSize(16);
      doc.setFont('helvetica', 'bold');
      doc.text('Trial Balance Report', 148, 15, { align: 'center' });

      doc.setFontSize(10);
      doc.setFont('helvetica', 'normal');
      doc.text(`Date Range: ${fromDate} to ${toDate}`, 148, 22, { align: 'center' });

      let yPosition = 25;
      const pageHeight = doc.internal.pageSize.height;
      const margin = 10;
      const pageWidth = doc.internal.pageSize.width - 2 * margin;

      // Helper function to check if we need a new page
      const checkNewPage = (requiredHeight = 15) => {
         if (yPosition + requiredHeight > pageHeight - 20) {
            doc.addPage();
            yPosition = 20;
            return true;
         }
         return false;
      };

      // Helper function to draw a filled rectangle
      const drawFilledRect = (x, y, width, height, color) => {
         doc.setFillColor(color[0], color[1], color[2]);
         doc.rect(x, y, width, height, 'F');
      };

      // Helper function to format currency
      const formatCurrency = (value) => {
         if (value === null || value === undefined) return '0.00';
         const numValue = Number(value);
         if (isNaN(numValue)) return '0.00';
         return `${numValue.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
      };

      if (reportType === 'Trail Balance Account') {
         // Process grouped data similar to your React component
         const groupedData = [];
         salesReport.forEach((company) => {
            if (company.data && Array.isArray(company.data)) {
               company.data.forEach((group) => {
                  if (group.gname) {
                     const groupInfo = {
                        groupName: group.gname,
                        groupTotal: group.totalAmount || 0,
                        companyName: company.companyName,
                        accounts: group.data || [],
                     };
                     groupedData.push(groupInfo);
                  }
               });
            }
         });

         const colWidths = [80, 40, 40, 40, 40];
         const colPositions = [margin, margin + 80, margin + 120, margin + 160, margin + 200];
         let previousCompanyName = null;

         groupedData.forEach((group) => {
            const isNewCompany = group.companyName !== previousCompanyName;

            if (isNewCompany) {
               checkNewPage(10);
               // Company header with background color
               drawFilledRect(margin, yPosition, pageWidth, 8, colors.companyHeader);
               doc.setFont('helvetica', 'bold');
               doc.setFontSize(8);
               doc.setTextColor(colors.headerText[0], colors.headerText[1], colors.headerText[2]);
               doc.text(group.companyName, margin + 2, yPosition + 6);
               yPosition += 8;
               previousCompanyName = group.companyName;
            }

            checkNewPage(15);
            // Group header with background color
            drawFilledRect(margin, yPosition, pageWidth, 8, colors.groupHeader);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.text(group.groupName, margin + 2, yPosition + 6);
            // Right align the group total
            doc.text(`Total: ${formatCurrency(group.groupTotal)}`, margin + pageWidth - 2, yPosition + 6, {
               align: 'right',
            });
            yPosition += 8;

            // Table headers
            checkNewPage(10);
            drawFilledRect(margin, yPosition, pageWidth, 6, colors.tableHeader);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            const headers = ['Account', 'Opening Balance', 'Total-Debits', 'Total-Credits', 'Closing Balance'];
            headers.forEach((header, i) => {
               if (i === 0) {
                  // Left align account name header
                  doc.text(header, colPositions[i] + 1, yPosition + 4);
               } else {
                  // Right align numeric headers
                  doc.text(header, colPositions[i] + colWidths[i] - 1, yPosition + 4, { align: 'right' });
               }
            });
            yPosition += 6;

            // Account rows
            group.accounts.forEach((account, index) => {
               checkNewPage(6);

               // Alternate row colors
               if (index % 2 === 1) {
                  drawFilledRect(margin, yPosition, pageWidth, 5, colors.alternateRow);
               }

               doc.setFont('helvetica', 'normal');
               doc.setFontSize(8);
               // Left align account name
               doc.text(account.accountName || '', colPositions[0] + 5, yPosition + 3.5);
               // Right align all numeric values
               doc.text(formatCurrency(account.OpeningAmount), colPositions[1] + colWidths[1] - 1, yPosition + 3.5, {
                  align: 'right',
               });
               doc.text(formatCurrency(account.debitAmount), colPositions[2] + colWidths[2] - 1, yPosition + 3.5, {
                  align: 'right',
               });
               doc.text(formatCurrency(account.creditAmount), colPositions[3] + colWidths[3] - 1, yPosition + 3.5, {
                  align: 'right',
               });
               doc.text(formatCurrency(account.closingAmount), colPositions[4] + colWidths[4] - 1, yPosition + 3.5, {
                  align: 'right',
               });
               yPosition += 6;
            });

            // yPosition += 3; // Space between groups
         });
      } else if (reportType === 'Trail Balance GL Group') {
         const colWidths = [80, 40, 40, 40, 40];
         const colPositions = [margin, margin + 80, margin + 120, margin + 160, margin + 200];

         trialBalanceFullGlGroup.forEach((company) => {
            checkNewPage(10);
            // Company header
            drawFilledRect(margin, yPosition, pageWidth, 8, colors.companyHeader);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.text(company.companyName, margin + 2, yPosition + 6);
            yPosition += 8;

            // Table headers
            checkNewPage(10);
            drawFilledRect(margin, yPosition, pageWidth, 6, colors.tableHeader);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            const headers = ['Account', 'Opening Balance', 'Total-Debits', 'Total-Credits', 'Closing Balance'];
            headers.forEach((header, i) => {
               if (i === 0) {
                  // Left align account name header
                  doc.text(header, colPositions[i] + 1, yPosition + 4);
               } else {
                  // Right align numeric headers
                  doc.text(header, colPositions[i] + colWidths[i] - 1, yPosition + 4, { align: 'right' });
               }
            });
            yPosition += 6;

            // Group data rows
            company.data.forEach((group, index) => {
               checkNewPage(6);

               if (index % 2 === 1) {
                  drawFilledRect(margin, yPosition, pageWidth, 5, colors.alternateRow);
               }

               doc.setFont('helvetica', 'bold');
               doc.setFontSize(8);
               // Left align group name
               doc.text(group.gname, colPositions[0] + 1, yPosition + 3.5);
               // Right align all numeric values
               doc.text(formatCurrency(group.OpeningAmount), colPositions[1] + colWidths[1] - 1, yPosition + 3.5, {
                  align: 'right',
               });
               doc.text(formatCurrency(group.debitAmount), colPositions[2] + colWidths[2] - 1, yPosition + 3.5, {
                  align: 'right',
               });
               doc.text(formatCurrency(group.creditAmount), colPositions[3] + colWidths[3] - 1, yPosition + 3.5, {
                  align: 'right',
               });
               doc.text(formatCurrency(group.closingAmount), colPositions[4] + colWidths[4] - 1, yPosition + 3.5, {
                  align: 'right',
               });
               yPosition += 6;
            });

            yPosition += 4; // Space between companies
         });
      } else if (reportType === 'Trail Balance Vertical') {
         // Group by company and GL group
         const groupedByCompany = {};

         trialBalance.forEach((company) => {
            const companyName = company.companyName || 'Unknown Company';
            if (!groupedByCompany[companyName]) {
               groupedByCompany[companyName] = {};
            }

            if (company.data && Array.isArray(company.data)) {
               company.data.forEach((group) => {
                  const groupName = group.gl_group_name || '-';
                  if (!groupedByCompany[companyName][groupName]) {
                     groupedByCompany[companyName][groupName] = {
                        accounts: [],
                        totalDebit: 0,
                        totalCredit: 0,
                     };
                  }
                  if (group.data && Array.isArray(group.data)) {
                     group.data.forEach((account) => {
                        groupedByCompany[companyName][groupName].accounts.push({
                           ...account,
                           debit_amount: Number(account.debit_amount || 0),
                           credit_amount: Number(account.credit_amount || 0),
                        });
                     });
                  }
               });
            }
         });

         // Calculate totals
         Object.keys(groupedByCompany).forEach((companyName) => {
            Object.keys(groupedByCompany[companyName]).forEach((groupName) => {
               const group = groupedByCompany[companyName][groupName];
               group.totalDebit = group.accounts.reduce((sum, account) => sum + account.debit_amount, 0);
               group.totalCredit = group.accounts.reduce((sum, account) => sum + account.credit_amount, 0);
            });
         });

         const colWidths = [60, 80, 60, 60];
         const colPositions = [margin, margin + 60, margin + 140, margin + 200];

         Object.entries(groupedByCompany).forEach(([companyName, groups]) => {
            checkNewPage(10);
            // Company header
            drawFilledRect(margin, yPosition, pageWidth, 8, colors.companyHeader);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            doc.text(companyName, margin + 2, yPosition + 6);
            yPosition += 8;

            // Table headers
            checkNewPage(8);
            drawFilledRect(margin, yPosition, pageWidth, 6, colors.tableHeader);
            doc.setFont('helvetica', 'bold');
            doc.setFontSize(8);
            const headers = ['Account Code', 'Account', 'Credits', 'Debits'];
            headers.forEach((header, i) => {
               if (i < 2) {
                  // Left align text headers
                  doc.text(header, colPositions[i] + 1, yPosition + 4);
               } else {
                  // Right align numeric headers
                  doc.text(header, colPositions[i] + colWidths[i] - 1, yPosition + 4, { align: 'right' });
               }
            });
            yPosition += 6;

            Object.entries(groups).forEach(([gl_group_name, groupData]) => {
               checkNewPage(8);
               // Group header
               drawFilledRect(margin, yPosition, pageWidth, 6, colors.verticalGroupHeader);
               doc.setFont('helvetica', 'bold');
               doc.setFontSize(8);
               doc.text(gl_group_name, margin + 2, yPosition + 4);
               // Right align group totals
               doc.text(formatCurrency(groupData.totalCredit), colPositions[2] + colWidths[2] - 1, yPosition + 4, {
                  align: 'right',
               });
               doc.text(formatCurrency(groupData.totalDebit), colPositions[3] + colWidths[3] - 1, yPosition + 4, {
                  align: 'right',
               });
               yPosition += 6;

               // Account rows
               groupData.accounts.forEach((account, index) => {
                  checkNewPage(5);

                  if (index % 2 === 1) {
                     drawFilledRect(margin, yPosition, pageWidth, 4, colors.alternateRow);
                  }

                  doc.setFont('helvetica', 'normal');
                  doc.setFontSize(8);
                  // Left align text fields
                  doc.text(account.account_group_code || '-', colPositions[0] + 8, yPosition + 3);
                  doc.text(account.account_name || '-', colPositions[1] + 1, yPosition + 3);
                  // Right align numeric fields
                  doc.text(
                     account.credit_amount !== 0 ? formatCurrency(account.credit_amount) : '0.00',
                     colPositions[2] + colWidths[2] - 1,
                     yPosition + 3,
                     { align: 'right' },
                  );
                  doc.text(
                     account.debit_amount !== 0 ? formatCurrency(account.debit_amount) : '0.00',
                     colPositions[3] + colWidths[3] - 1,
                     yPosition + 3,
                     { align: 'right' },
                  );
                  yPosition += 4;
               });
            });
            yPosition += 3; // Space between companies
         });
      } else if (reportType === 'Trail Balance T Format') {
         // Process data similar to your React component
         const companiesData = {};

         trialBalance.forEach((company) => {
            const companyName = company.companyName || 'Unknown Company';
            if (!companiesData[companyName]) {
               companiesData[companyName] = {
                  creditGroups: [],
                  debitGroups: [],
               };
            }

            const groups = company.data && Array.isArray(company.data) ? company.data : [company];
            groups.forEach((group) => {
               if (group.data && group.data.length > 0) {
                  const totalCredit = group.data.reduce((sum, acc) => sum + (acc.credit_amount || 0), 0);
                  const totalDebit = group.data.reduce((sum, acc) => sum + (acc.debit_amount || 0), 0);

                  if (totalCredit >= totalDebit) {
                     companiesData[companyName].creditGroups.push(group);
                  } else {
                     companiesData[companyName].debitGroups.push(group);
                  }
               }
            });
         });

         // Calculate grand totals
         let grandTotalCredit = 0;
         let grandTotalDebit = 0;

         Object.values(companiesData).forEach((company) => {
            company.creditGroups.forEach((group) => {
               grandTotalCredit += group.data.reduce((sum, acc) => sum + (acc.credit_amount || 0), 0);
            });
            company.debitGroups.forEach((group) => {
               grandTotalDebit += group.data.reduce((sum, acc) => sum + (acc.debit_amount || 0), 0);
            });
         });

         const halfWidth = pageWidth / 2;
         const creditStartX = margin;
         const debitStartX = margin + halfWidth;

         // T-Format headers
         checkNewPage(15);
         drawFilledRect(creditStartX, yPosition, halfWidth - 2, 8, colors.tFormatCreditHeader);
         drawFilledRect(debitStartX + 2, yPosition, halfWidth - 2, 8, colors.tFormatDebitHeader);

         doc.setFont('helvetica', 'bold');
         doc.setFontSize(8);
         doc.text('CREDIT', creditStartX + halfWidth / 2 - 2, yPosition + 6, { align: 'center' });
         doc.text('DEBIT', debitStartX + halfWidth / 2 + 2, yPosition + 6, { align: 'center' });
         yPosition += 8;

         // Column headers
         checkNewPage(8);
         drawFilledRect(creditStartX, yPosition, halfWidth - 2, 6, colors.tableHeader);
         drawFilledRect(debitStartX + 2, yPosition, halfWidth - 2, 6, colors.tableHeader);

         doc.setFont('helvetica', 'bold');
         doc.setFontSize(8);
         // Left align account headers
         doc.text('Account', creditStartX + 2, yPosition + 4);
         doc.text('Account', debitStartX + 4, yPosition + 4);
         // Right align amount headers
         doc.text('Amount', creditStartX + halfWidth - 4, yPosition + 4, { align: 'right' });
         doc.text('Amount', debitStartX + halfWidth - 2, yPosition + 4, { align: 'right' });
         yPosition += 6;

         Object.entries(companiesData).forEach(([companyName, companyData]) => {
            if (companyData.creditGroups.length > 0 || companyData.debitGroups.length > 0) {
               checkNewPage(10);

               // Company name for both sides
               drawFilledRect(creditStartX, yPosition, halfWidth - 2, 6, colors.companyHeader);
               drawFilledRect(debitStartX + 2, yPosition, halfWidth - 2, 6, colors.companyHeader);

               doc.setFont('helvetica', 'bold');
               doc.setFontSize(8);
               doc.text(companyName, creditStartX + 2, yPosition + 4);
               doc.text(companyName, debitStartX + 4, yPosition + 4);
               yPosition += 6;

               const maxGroups = Math.max(companyData.creditGroups.length, companyData.debitGroups.length);

               for (let i = 0; i < maxGroups; i++) {
                  const creditGroup = companyData.creditGroups[i];
                  const debitGroup = companyData.debitGroups[i];

                  checkNewPage(8);

                  // Group headers
                  if (creditGroup) {
                     drawFilledRect(creditStartX, yPosition, halfWidth - 2, 5, colors.tFormatCreditHeader);
                     doc.setFont('helvetica', 'bold');
                     doc.setFontSize(8);
                     doc.text(creditGroup.gl_group_name, creditStartX + 2, yPosition + 3.5);
                     const groupTotal = creditGroup.data.reduce((sum, acc) => sum + (acc.credit_amount || 0), 0);
                     // Right align group total
                     doc.text(`Total: ${formatCurrency(groupTotal)}`, creditStartX + halfWidth - 4, yPosition + 3.5, {
                        align: 'right',
                     });
                  }

                  if (debitGroup) {
                     drawFilledRect(debitStartX + 2, yPosition, halfWidth - 2, 5, colors.tFormatDebitHeader);
                     doc.setFont('helvetica', 'bold');
                     doc.setFontSize(8);
                     doc.text(debitGroup.gl_group_name, debitStartX + 4, yPosition + 3.5);
                     const groupTotal = debitGroup.data.reduce((sum, acc) => sum + (acc.debit_amount || 0), 0);
                     // Right align group total
                     doc.text(`Total: ${formatCurrency(groupTotal)}`, debitStartX + halfWidth - 2, yPosition + 3.5, {
                        align: 'right',
                     });
                  }
                  yPosition += 7;

                  // Account details
                  const maxAccounts = Math.max(
                     creditGroup ? creditGroup.data.filter((acc) => (acc.credit_amount || 0) > 0).length : 0,
                     debitGroup ? debitGroup.data.filter((acc) => (acc.debit_amount || 0) > 0).length : 0,
                  );

                  for (let j = 0; j < maxAccounts; j++) {
                     checkNewPage(5);

                     const creditAccounts = creditGroup
                        ? creditGroup.data.filter((acc) => (acc.credit_amount || 0) > 0)
                        : [];
                     const debitAccounts = debitGroup
                        ? debitGroup.data.filter((acc) => (acc.debit_amount || 0) > 0)
                        : [];

                     const creditAccount = creditAccounts[j];
                     const debitAccount = debitAccounts[j];

                     doc.setFont('helvetica', 'normal');
                     doc.setFontSize(7);

                     if (creditAccount) {
                        // Left align account name
                        doc.text(creditAccount.account_name, creditStartX + 8, yPosition + 3);
                        // Right align amount
                        doc.text(
                           formatCurrency(creditAccount.credit_amount),
                           creditStartX + halfWidth - 4,
                           yPosition + 3,
                           { align: 'right' },
                        );
                     }

                     if (debitAccount) {
                        // Left align account name
                        doc.text(debitAccount.account_name, debitStartX + 10, yPosition + 3);
                        // Right align amount
                        doc.text(
                           formatCurrency(debitAccount.debit_amount),
                           debitStartX + halfWidth - 2,
                           yPosition + 3,
                           { align: 'right' },
                        );
                     }

                     yPosition += 4;
                  }
                  yPosition += 2;
               }
            }
         });

         // Grand totals
         checkNewPage(8);
         drawFilledRect(creditStartX, yPosition, halfWidth - 2, 6, colors.tFormatCreditHeader);
         drawFilledRect(debitStartX + 2, yPosition, halfWidth - 2, 6, colors.tFormatDebitHeader);

         doc.setFont('helvetica', 'bold');
         doc.setFontSize(8);
         // Left align labels
         doc.text('Grand Total:', creditStartX + 2, yPosition + 4);
         doc.text('Grand Total:', debitStartX + 4, yPosition + 4);
         // Right align totals
         doc.text(formatCurrency(grandTotalCredit), creditStartX + halfWidth - 4, yPosition + 4, { align: 'right' });
         doc.text(formatCurrency(grandTotalDebit), debitStartX + halfWidth - 2, yPosition + 4, { align: 'right' });
      }

      doc.save('TrialBalance_Styled.pdf');
   };

   // Column Visibility Modal - Updated for Trial Balance columns
   const ColumnVisibilityModal = () => (
      <Modal isOpen={isColumnSelectorOpen} onClose={() => setIsColumnSelectorOpen(false)} size="md">
         <ModalOverlay />
         <ModalContent>
            <ModalHeader>Show/Hide Columns</ModalHeader>
            <ModalCloseButton />
            <ModalBody>
               {trialBalanceColumns.map((column) => (
                  <Flex key={column.id} mb={2} alignItems="center">
                     <Checkbox
                        isChecked={!!columnVisibility[column.id]}
                        onChange={(e) => {
                           table.setColumnVisibility((prev) => ({
                              ...prev,
                              [column.id]: e.target.checked,
                           }));
                        }}
                        mr={2}
                     />
                     <Text>{column.header}</Text>
                  </Flex>
               ))}
            </ModalBody>
            <ModalFooter>
               <Button colorScheme="blue" onClick={() => setIsColumnSelectorOpen(false)}>
                  Close
               </Button>
            </ModalFooter>
         </ModalContent>
      </Modal>
   );

   const renderReportContent = () => {
      if (isLoading) {
         return (
            <Tr>
               <Td colSpan={table.getVisibleFlatColumns().length} textAlign="center" py="100px">
                  <Loader />
               </Td>
            </Tr>
         );
      }
      if (
         (!salesReport || salesReport.length === 0) &&
         (!trialBalanceFullGlGroup || trialBalanceFullGlGroup.length === 0) &&
         (!trialBalance || trialBalance.length === 0)
      ) {
         return (
            <Tr justifyContent="center" alignItems="center" width="100%" height="100%">
               <Td
                  p="2px"
                  py="3px"
                  fontSize="10px"
                  whiteSpace="nowrap"
                  textOverflow="ellipsis"
                  maxW="150px"
                  overflow="hidden"
                  colSpan={table.getVisibleFlatColumns().length}
                  justifyContent="center"
                  alignItems="center"
                  width="100%">
                  <Grid justifyContent="center" alignItems="center" gap={9}>
                     <img src={nodata} alt="No Data Found" width="200px" height="200px" />
                     <GridItem justifySelf="center">
                        <label>No trial balance data found</label>
                     </GridItem>
                  </Grid>
               </Td>
            </Tr>
         );
      }

      // Format currency values helper function
      const formatCurrency = (value) => {
         if (value === null || value === undefined) return '-';
         const numValue = Number(value);
         if (isNaN(numValue)) return value;
         return `₹${numValue.toLocaleString('en-IN', { maximumFractionDigits: 2 })}`;
      };

      if (reportType === 'Trail Balance Vertical') {
         // First group by company, then by gl_group_name
         const groupedByCompany = {};

         trialBalance.forEach((company) => {
            const companyName = company.companyName || 'Unknown Company';

            if (!groupedByCompany[companyName]) {
               groupedByCompany[companyName] = {};
            }

            // Process company data (either nested in data array or direct accounts)
            if (company.data && Array.isArray(company.data)) {
               company.data.forEach((group) => {
                  const groupName = group.gl_group_name || '-';

                  if (!groupedByCompany[companyName][groupName]) {
                     groupedByCompany[companyName][groupName] = {
                        accounts: [],
                        totalDebit: 0,
                        totalCredit: 0,
                     };
                  }

                  if (group.data && Array.isArray(group.data)) {
                     group.data.forEach((account) => {
                        groupedByCompany[companyName][groupName].accounts.push({
                           ...account,
                           debit_amount: Number(account.debit_amount || 0),
                           credit_amount: Number(account.credit_amount || 0),
                        });
                     });
                  }
               });
            } else if (company.account_name) {
               // Handle direct account data
               const groupName = company.gl_group_name || '-';

               if (!groupedByCompany[companyName][groupName]) {
                  groupedByCompany[companyName][groupName] = {
                     accounts: [],
                     totalDebit: 0,
                     totalCredit: 0,
                  };
               }

               groupedByCompany[companyName][groupName].accounts.push({
                  ...company,
                  debit_amount: Number(company.debit_amount || 0),
                  credit_amount: Number(company.credit_amount || 0),
               });
            }
         });

         // Calculate totals for each group
         Object.keys(groupedByCompany).forEach((companyName) => {
            Object.keys(groupedByCompany[companyName]).forEach((groupName) => {
               const group = groupedByCompany[companyName][groupName];
               group.totalDebit = group.accounts.reduce((sum, account) => sum + account.debit_amount, 0);
               group.totalCredit = group.accounts.reduce((sum, account) => sum + account.credit_amount, 0);
            });
         });

         return (
            <>
               {Object.entries(groupedByCompany).map(([companyName, groups], companyIndex) => (
                  <React.Fragment key={`company-${companyIndex}`}>
                     {/* Company Name Row - only once per company */}
                     <Tr bg="#F0EBE3" _dark={{ bg: '#0d1b3b' }}>
                        <Td
                           colSpan={5}
                           p="4px"
                           fontSize="15px"
                           fontWeight="bold"
                           color={textColor}
                           borderColor={borderColor}>
                           {companyName}
                        </Td>
                     </Tr>

                     {/* Groups for this company */}
                     {Object.entries(groups).map(([gl_group_name, groupData], groupIndex) => (
                        <React.Fragment key={`group-${companyIndex}-${groupIndex}`}>
                           <Tr bg={'#E3F2FD'} _dark={{ bg: '#1E3A8A' }}>
                              <Td
                                 p="4px 8px"
                                 fontSize={'16px'}
                                 fontWeight="bold"
                                 color={textColor}
                                 borderColor={borderColor}
                                 colSpan={2}>
                                 {gl_group_name}
                              </Td>
                              <Td
                                 p="2px"
                                 fontSize={'14px'}
                                 fontWeight="semibold"
                                 color={textColor}
                                 borderColor={borderColor}
                                 isNumeric>
                                 {formatCurrency(groupData.totalCredit)}
                              </Td>
                              <Td
                                 p="2px"
                                 fontSize={'14px'}
                                 fontWeight="semibold"
                                 color={textColor}
                                 borderColor={borderColor}
                                 isNumeric>
                                 {formatCurrency(groupData.totalDebit)}
                              </Td>
                           </Tr>

                           {/* Accounts for this group */}
                           {groupData.accounts.map((account, accountIndex) => (
                              <Tr
                                 key={`account-${companyIndex}-${groupIndex}-${accountIndex}`}
                                 bg={accountIndex % 2 === 0 ? 'white' : 'rgba(0, 63, 140, 0.05)'}
                                 _dark={{ bg: accountIndex % 2 === 0 ? '#101F4A' : 'rgba(2, 14, 56, 0.7)' }}>
                                 <Td
                                    p="2px 16px"
                                    fontSize={'14px'}
                                    color={textColor}
                                    borderColor={borderColor}
                                    pl="24px">
                                    {account.account_group_code || '-'}
                                 </Td>
                                 <Td p="2px" fontSize={'14px'} color={textColor} borderColor={borderColor}>
                                    {account.account_name || '-'}
                                 </Td>
                                 <Td p="2px" fontSize={'14px'} color={textColor} borderColor={borderColor} isNumeric>
                                    {account.credit_amount !== 0 ? formatCurrency(account.credit_amount) : '0.00'}
                                 </Td>
                                 <Td p="2px" fontSize={'14px'} color={textColor} borderColor={borderColor} isNumeric>
                                    {account.debit_amount !== 0 ? formatCurrency(account.debit_amount) : '0.00'}
                                 </Td>
                              </Tr>
                           ))}
                        </React.Fragment>
                     ))}
                  </React.Fragment>
               ))}
            </>
         );
      }

      // Handle GL Group report type
      if (reportType === 'Trail Balance GL Group') {
         const allGLGroupData = [];

         trialBalanceFullGlGroup.forEach((group) => {
            if (group.data && Array.isArray(group.data)) {
               allGLGroupData.push(group);
            } else {
               // Handle direct GL group data
               allGLGroupData.push(group);
            }
         });

         return allGLGroupData.map((maingroup, mainIndex) => {
            return (
               <React.Fragment key={`main-group-${mainIndex}`}>
                  {/* Company Name Row */}
                  <Tr bg="#F0EBE3" _dark={{ bg: '#0d1b3b' }}>
                     <Td
                        colSpan={5}
                        p="4px"
                        fontSize="15px"
                        fontWeight="bold"
                        color={textColor}
                        borderColor={borderColor}>
                        {maingroup.companyName}
                     </Td>
                  </Tr>

                  {/* Group Rows */}
                  {maingroup.data.map((group, index) => {
                     return (
                        <Tr
                           key={`gl-group-${mainIndex}-${index}`}
                           bg={index % 2 === 0 ? 'white' : 'rgba(0, 63, 140, 0.05)'}
                           _dark={{ bg: index % 2 === 0 ? '#101F4A' : 'rgba(2, 14, 56, 0.7)' }}>
                           <Td p="2px" fontSize="14px" fontWeight="bold" color={textColor} borderColor={borderColor}>
                              {group.gname}
                           </Td>
                           <Td
                              p="2px"
                              fontSize="14px"
                              fontWeight="bold"
                              color={textColor}
                              borderColor={borderColor}
                              isNumeric>
                              {formatCurrency(group.OpeningAmount || 0)}
                           </Td>
                           <Td
                              p="2px"
                              fontSize="14px"
                              fontWeight="bold"
                              color={textColor}
                              borderColor={borderColor}
                              isNumeric>
                              {formatCurrency(group.debitAmount || 0)}
                           </Td>
                           <Td
                              p="2px"
                              fontSize="14px"
                              fontWeight="bold"
                              color={textColor}
                              borderColor={borderColor}
                              isNumeric>
                              {formatCurrency(group.creditAmount || 0)}
                           </Td>
                           <Td
                              p="2px"
                              fontSize="14px"
                              fontWeight="bold"
                              color={textColor}
                              borderColor={borderColor}
                              isNumeric>
                              {formatCurrency(group.closingAmount || 0)}
                           </Td>
                        </Tr>
                     );
                  })}
               </React.Fragment>
            );
         });
      }

      // Handle T-Format report type
      if (reportType === 'Trail Balance T Format') {
         // First group by company
         const companiesData = {};

         trialBalance.forEach((company) => {
            const companyName = company.companyName || 'Unknown Company';

            if (!companiesData[companyName]) {
               companiesData[companyName] = {
                  creditGroups: [],
                  debitGroups: [],
               };
            }

            // Process company data (either nested in data array or direct accounts)
            const groups = company.data && Array.isArray(company.data) ? company.data : [company];

            groups.forEach((group) => {
               if (group.data && group.data.length > 0) {
                  const totalCredit = group.data.reduce((sum, acc) => sum + (acc.credit_amount || 0), 0);
                  const totalDebit = group.data.reduce((sum, acc) => sum + (acc.debit_amount || 0), 0);

                  if (totalCredit >= totalDebit) {
                     companiesData[companyName].creditGroups.push(group);
                  } else {
                     companiesData[companyName].debitGroups.push(group);
                  }
               }
            });
         });

         // Calculate grand totals
         let grandTotalCredit = 0;
         let grandTotalDebit = 0;

         Object.values(companiesData).forEach((company) => {
            company.creditGroups.forEach((group) => {
               grandTotalCredit += group.data.reduce((sum, acc) => sum + (acc.credit_amount || 0), 0);
            });
            company.debitGroups.forEach((group) => {
               grandTotalDebit += group.data.reduce((sum, acc) => sum + (acc.debit_amount || 0), 0);
            });
         });

         return (
            <div style={{ display: 'flex', width: '100%', flexDirection: 'column' }}>
               <div style={{ display: 'flex', width: '100%' }}>
                  {/* Credit Side (Left) */}
                  <div style={{ width: '50%', borderRight: `2px solid ${borderColor}`, paddingRight: '10px' }}>
                     <div
                        style={{
                           textAlign: 'center',
                           fontWeight: 'bold',
                           fontSize: '16px',
                           padding: '10px',
                           backgroundColor: '#F1F0E8',
                           borderBottom: `1px solid ${borderColor}`,
                           color: 'black',
                        }}>
                        CREDIT
                     </div>

                     <Table variant="simple" size="sm">
                        <Thead>
                           <Tr bg={'#F5F5F5'} _dark={{ bg: '#080238' }}>
                              <Th fontSize="12px" color={textColor} borderColor={borderColor} p="4px">
                                 Account
                              </Th>
                              <Th fontSize="12px" color={textColor} borderColor={borderColor} p="4px" isNumeric>
                                 Amount
                              </Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {Object.entries(companiesData).map(
                              ([companyName, companyData]) =>
                                 companyData.creditGroups.length > 0 && (
                                    <React.Fragment key={`credit-company-${companyName}`}>
                                       {/* Company Name Row - only once per company */}
                                       <Tr bg="#F1F0E8" _dark={{ bg: '#0d1b3b' }}>
                                          <Td
                                             colSpan={2}
                                             p="4px"
                                             fontSize="14px"
                                             fontWeight="bold"
                                             color={textColor}
                                             borderColor={borderColor}>
                                             {companyName}
                                          </Td>
                                       </Tr>

                                       {/* Groups for this company */}
                                       {companyData.creditGroups.map((group, groupIndex) => (
                                          <React.Fragment key={`credit-group-${groupIndex}`}>
                                             {/* Group Header */}
                                             <Tr bg={'#F5EEE6'} _dark={{ bg: '#080238' }}>
                                                <Td
                                                   colSpan={2}
                                                   p="4px"
                                                   fontSize="14px"
                                                   fontWeight="bold"
                                                   color={textColor}
                                                   borderColor={borderColor}>
                                                   {group.gl_group_name}
                                                   <span style={{ float: 'right' }}>
                                                      Total:{' '}
                                                      {formatCurrency(
                                                         group.data.reduce(
                                                            (sum, acc) => sum + (acc.credit_amount || 0),
                                                            0,
                                                         ),
                                                      )}
                                                   </span>
                                                </Td>
                                             </Tr>

                                             {/* Accounts in this group that have credit balance */}
                                             {group.data
                                                .filter((account) => (account.credit_amount || 0) > 0)
                                                .map((account, accIndex) => (
                                                   <Tr key={`credit-acc-${accIndex}`}>
                                                      <Td
                                                         p="4px"
                                                         fontSize="14px"
                                                         color={textColor}
                                                         borderColor={borderColor}
                                                         paddingLeft="15px">
                                                         {account.account_name}
                                                      </Td>
                                                      <Td
                                                         p="4px"
                                                         fontSize="14px"
                                                         color={textColor}
                                                         borderColor={borderColor}
                                                         isNumeric>
                                                         {formatCurrency(account.credit_amount)}
                                                      </Td>
                                                   </Tr>
                                                ))}
                                          </React.Fragment>
                                       ))}
                                    </React.Fragment>
                                 ),
                           )}
                        </Tbody>
                     </Table>
                  </div>

                  {/* Debit Side (Right) */}
                  <div style={{ width: '50%', paddingLeft: '10px' }}>
                     <Box
                        textAlign="center"
                        fontWeight="bold"
                        fontSize="16px"
                        p="10px"
                        bg="rgba(0, 63, 140, 0.1)"
                        borderBottom={`1px solid ${borderColor}`}
                        color="black"
                        _dark={{ color: '#FFF' }}>
                        DEBIT
                     </Box>

                     <Table variant="simple" size="sm">
                        <Thead>
                           <Tr bg={'#F5F5F5'} _dark={{ bg: '#080238' }}>
                              <Th fontSize="12px" color={textColor} borderColor={borderColor} p="4px">
                                 Account
                              </Th>
                              <Th fontSize="12px" color={textColor} borderColor={borderColor} p="4px" isNumeric>
                                 Amount
                              </Th>
                           </Tr>
                        </Thead>
                        <Tbody>
                           {Object.entries(companiesData).map(
                              ([companyName, companyData]) =>
                                 companyData.debitGroups.length > 0 && (
                                    <React.Fragment key={`debit-company-${companyName}`}>
                                       {/* Company Name Row - only once per company */}
                                       <Tr bg="#9EB8D9" _dark={{ bg: '#0d1b3b' }}>
                                          <Td
                                             colSpan={2}
                                             p="4px"
                                             fontSize="14px"
                                             fontWeight="bold"
                                             color={textColor}
                                             borderColor={borderColor}>
                                             {companyName}
                                          </Td>
                                       </Tr>

                                       {/* Groups for this company */}
                                       {companyData.debitGroups.map((group, groupIndex) => (
                                          <React.Fragment key={`debit-group-${groupIndex}`}>
                                             {/* Group Header */}
                                             <Tr>
                                                <Td
                                                   colSpan={2}
                                                   p="4px"
                                                   fontSize="14px"
                                                   fontWeight="bold"
                                                   color={textColor}
                                                   borderColor={borderColor}
                                                   bg="rgba(0, 63, 140, 0.1)"
                                                   _dark={{ bg: 'rgba(2, 14, 56, 0.5)' }}>
                                                   {group.gl_group_name}
                                                   <span style={{ float: 'right' }}>
                                                      Total:{' '}
                                                      {formatCurrency(
                                                         group.data.reduce(
                                                            (sum, acc) => sum + (acc.debit_amount || 0),
                                                            0,
                                                         ),
                                                      )}
                                                   </span>
                                                </Td>
                                             </Tr>

                                             {/* Accounts in this group that have debit balance */}
                                             {group.data
                                                .filter((account) => (account.debit_amount || 0) > 0)
                                                .map((account, accIndex) => (
                                                   <Tr key={`debit-acc-${accIndex}`}>
                                                      <Td
                                                         p="4px"
                                                         fontSize="14px"
                                                         color={textColor}
                                                         borderColor={borderColor}
                                                         paddingLeft="15px">
                                                         {account.account_name}
                                                      </Td>
                                                      <Td
                                                         p="4px"
                                                         fontSize="14px"
                                                         color={textColor}
                                                         borderColor={borderColor}
                                                         isNumeric>
                                                         {formatCurrency(account.debit_amount)}
                                                      </Td>
                                                   </Tr>
                                                ))}
                                          </React.Fragment>
                                       ))}
                                    </React.Fragment>
                                 ),
                           )}
                        </Tbody>
                     </Table>
                  </div>
               </div>

               {/* Combined Grand Total at Bottom */}
               <div
                  style={{
                     display: 'flex',
                     width: '100%',
                     // marginTop: '10px',
                  }}>
                  {/* Credit Grand Total */}
                  <div
                     style={{
                        width: '50%',
                        backgroundColor: '#F1F0E8',
                        padding: '8px',
                        borderTop: `2px solid ${borderColor}`,
                        borderRight: `2px solid ${borderColor}`,
                        display: 'flex',
                        justifyContent: 'space-between',
                        fontWeight: 'bold',
                        fontSize: '15px',
                        color: 'black',
                        paddingRight: '10px',
                     }}>
                     <span>Credit Grand Total :</span>
                     <span>{formatCurrency(grandTotalCredit)}</span>
                  </div>

                  {/* Debit Grand Total */}
                  <div
                     style={{
                        width: '50%',
                        backgroundColor: '#9EB8D9',
                        padding: '8px',
                        borderTop: `2px solid ${borderColor}`,
                        display: 'flex',
                        justifyContent: 'space-between',
                        fontWeight: 'bold',
                        fontSize: '15px',
                        color: 'black',
                        paddingLeft: '10px',
                     }}>
                     <span>Debit Grand Total :</span>
                     <span>{formatCurrency(grandTotalDebit)}</span>
                  </div>
               </div>
            </div>
         );
      }

      // Handle Vertical report type with grouped display
      if (reportType === 'Trail Balance Account') {
         const groupedData = [];
         let totalGroupAmount = 0;

         salesReport.forEach((company) => {
            if (company.data && Array.isArray(company.data)) {
               // Process each group in the company data
               company.data.forEach((group) => {
                  if (group.gname) {
                     const groupInfo = {
                        groupName: group.gname,
                        groupTotal: group.totalAmount || 0,
                        companyName: company.companyName,
                        accounts: [],
                     };

                     // Add accounts from this group
                     if (group.data && Array.isArray(group.data)) {
                        group.data.forEach((account) => {
                           groupInfo.accounts.push(account);
                        });
                     }

                     groupedData.push(groupInfo);
                     totalGroupAmount += Number(group.totalAmount || 0);
                  }
               });
            }
         });

         const allRows = [];
         let rowIndex = 0;
         let previousCompanyName = null;

         groupedData.forEach((group, groupIndex) => {
            const isNewCompany = group.companyName !== previousCompanyName;
            // Group Header Row
            if (isNewCompany) {
               // Push company name row
               allRows.push(
                  <Tr
                     key={`company-name-${groupIndex}`}
                     bg={'#F0EBE3'}
                     _dark={{ bg: '#1A365D' }}
                     borderTop="2px solid"
                     borderColor={borderColor}>
                     <Td
                        p="8px"
                        fontSize={'14px'}
                        color={textColor}
                        borderColor={borderColor}
                        fontWeight="bold"
                        colSpan={5}
                        textAlign="left">
                        <Flex justifyContent="space-between" alignItems="center">
                           <Text>{group.companyName}</Text>
                        </Flex>
                     </Td>
                  </Tr>,
               );
               previousCompanyName = group.companyName; // Update tracker
            }

            allRows.push(
               <Tr
                  key={`group-header-${groupIndex}`}
                  bg={'#E8F4FD'}
                  _dark={{ bg: '#1A365D' }}
                  borderTop="2px solid"
                  borderColor={borderColor}>
                  <Td
                     p="8px"
                     fontSize={'14px'}
                     color={textColor}
                     borderColor={borderColor}
                     fontWeight="bold"
                     colSpan={5}
                     textAlign="left">
                     <Flex justifyContent="space-between" alignItems="center">
                        <Text>{group.groupName}</Text>
                        <Text fontWeight="bold">Total Amount: {formatCurrency(group.groupTotal)}</Text>
                     </Flex>
                  </Td>
               </Tr>,
            );

            // Group Account Rows
            if (group.accounts && group.accounts.length > 0) {
               group.accounts.forEach((account, accountIndex) => {
                  allRows.push(
                     <Tr
                        key={`account-${groupIndex}-${accountIndex}`}
                        bg={rowIndex % 2 === 0 ? 'white' : 'rgba(0, 63, 140, 0.05)'}
                        _dark={{ bg: rowIndex % 2 === 0 ? '#101F4A' : 'rgba(2, 14, 56, 0.7)' }}>
                        <Td p="2px" fontSize={'12px'} color={textColor} borderColor={borderColor} paddingLeft="20px">
                           {account.accountName}
                        </Td>
                        <Td p="2px" fontSize={'12px'} color={textColor} borderColor={borderColor} isNumeric>
                           {formatCurrency(account.OpeningAmount) || '0.00'}
                        </Td>
                        <Td p="2px" fontSize={'12px'} color={textColor} borderColor={borderColor} isNumeric>
                           {formatCurrency(account.debitAmount) || '0.00'}
                        </Td>
                        <Td p="2px" fontSize={'12px'} color={textColor} borderColor={borderColor} isNumeric>
                           {formatCurrency(account.creditAmount) || '0.00'}
                        </Td>
                        <Td p="2px" fontSize={'12px'} color={textColor} borderColor={borderColor} isNumeric>
                           {formatCurrency(account.closingAmount) || '0.00'}
                        </Td>
                     </Tr>,
                  );
                  rowIndex++;
               });
            } else {
               // Show "No data" row if group has no accounts
               allRows.push(
                  <Tr
                     key={`no-data-${groupIndex}`}
                     bg={rowIndex % 2 === 0 ? 'white' : 'rgba(0, 63, 140, 0.05)'}
                     _dark={{ bg: rowIndex % 2 === 0 ? '#101F4A' : 'rgba(2, 14, 56, 0.7)' }}>
                     <Td
                        p="2px"
                        fontSize={'12px'}
                        color={textColor}
                        borderColor={borderColor}
                        colSpan={5}
                        textAlign="center"
                        fontStyle="italic"
                        paddingLeft="20px">
                        No accounts found for this group
                     </Td>
                  </Tr>,
               );
               rowIndex++;
            }
         });

         return allRows;
      }

      // Default table rendering for other cases
      return (
         <>
            {table.getRowModel().rows.map((row, index) => (
               <Tr
                  key={row.id}
                  bg={index % 2 === 0 ? 'white' : 'rgba(0, 63, 140, 0.05)'}
                  _dark={{ bg: index % 2 === 0 ? '#101F4A' : 'rgba(2, 14, 56, 0.7)' }}>
                  {row.getVisibleCells().map((cell) => (
                     <Td key={cell.id} p="10px" borderColor={borderColor}>
                        {flexRender(cell.column.columnDef.cell, cell.getContext())}
                     </Td>
                  ))}
               </Tr>
            ))}
         </>
      );
   };
   return (
      <>
         {/* Title Outside Card */}
         <Flex pr="25px" mb="5px" justifyContent="space-between" align="center" mt="50px" overflow={'hidden'}>
            <Flex>
               <img
                  src={back}
                  alt="Go Back"
                  width="15px"
                  onClick={() => window.history.back()}
                  style={{ cursor: 'pointer' }}
               />
               <Text color={textColor} fontSize="15px" fontWeight="700" lineHeight="100%" ml={5}>
                  Trial Balance
               </Text>
            </Flex>
            <Flex></Flex>
         </Flex>

         <Box mt="15px" bg={backgroundColor} px={4} py={0} borderRadius="7px">
            <Flex alignItems="center" gap={3} justifyContent={'end'}>
               <div flex="1" mr={''} justifyContent="center">
                  <Box my={2} width="300px" fontSize={'13px'} fontWeight={500} display={{ base: 'none', xl: 'block' }}>
                     <GridItem className="seperator-width" mt={5}>
                        {renderDynamicDropdown(
                           'company',
                           'Company',
                           lastcompanyOptions,
                           {
                              value: companyFilter,
                              onChange: handleCompanyChange,
                           },
                           {},
                           textColor,
                           false,
                           'Select company',
                           true,
                           undefined,
                           true,
                        )}
                     </GridItem>
                  </Box>
               </div>
               <Box flex="1" display={{ base: 'none', xl: 'flex' }}>
                  <Flex alignItems={'center'} mt={3}>
                     <PeriodDatePicker
                        value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                        onChange={handleDateRangeChange}
                        defaultPeriod="last7Days"
                        style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                     />
                  </Flex>
                  <Box my={2} zIndex={3} fontSize={'13px'} fontWeight={500}>
                     <label>Report Type</label>
                     <Select
                        options={reportTypeOptions}
                        value={reportTypeOptions.find((option) => option.value === reportType)}
                        onChange={(selectedOption) => {
                           setReportType(selectedOption.value);
                           setExpandedItems({});
                        }}
                        placeholder="Select Report Type"
                        styles={{
                           control: (baseStyles, state) => ({
                              ...baseStyles,
                              minHeight: '30px',
                              height: '30px',
                              backgroundColor: controlBg,
                              borderColor: controlBorder,
                              boxShadow: state.isFocused ? focusBoxShadow : baseStyles.boxShadow,
                              '&:hover': {
                                 borderColor: controlBorderHover,
                              },
                           }),
                           valueContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                              padding: '0 6px',
                              color: textColor,
                           }),
                           indicatorsContainer: (baseStyles) => ({
                              ...baseStyles,
                              height: '30px',
                           }),
                           singleValue: (baseStyles) => ({
                              ...baseStyles,
                              color: textColor,
                           }),
                           placeholder: (baseStyles) => ({
                              ...baseStyles,
                              color: placeholderColor,
                           }),
                           option: (baseStyles, state) => ({
                              ...baseStyles,
                              backgroundColor: state.isFocused ? optionHoverBg : optionBg,
                              color: textColor,
                              '&:hover': {
                                 backgroundColor: optionHoverBg,
                              },
                           }),
                           menu: (baseStyles) => ({
                              ...baseStyles,
                              backgroundColor: menuBg,
                              border: `1px solid ${menuBorder}`,
                           }),
                           dropdownIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                           clearIndicator: (baseStyles) => ({
                              ...baseStyles,
                              color: indicatorColor,
                              '&:hover': {
                                 color: indicatorHoverColor,
                              },
                           }),
                        }}
                     />
                  </Box>
               </Box>
               <Flex>
                  <Box flex="1" mr={3}>
                     <MotionFlex
                        ref={wrapperRef}
                        align="center"
                        bg={bg}
                        borderRadius="full"
                        cursor="pointer"
                        px={expanded ? 3 : 0}
                        w={expanded ? '250px' : '40px'}
                        h="40px"
                        transition="all 0.3s ease"
                        onClick={() => setExpanded(true)}>
                        <MotionSearchIcon
                           color={icon}
                           animate={{ rotate: expanded ? 0 : 90 }}
                           transition={{ duration: 0.3 }}
                           style={{
                              marginRight: expanded ? '8px' : '10px',
                              marginLeft: expanded ? '0' : '10px',
                           }}
                        />
                        {expanded && (
                           <Input
                              variant="unstyled"
                              placeholder="Search accounts..."
                              value={searchQuery}
                              onChange={handleSearchChange}
                              color={icon}
                              flex="1"
                           />
                        )}
                     </MotionFlex>
                  </Box>
                  <Button onClick={handleRefresh} _hover={{ bg: 'blue.50' }} mr={2}>
                     <LuRefreshCcw size={20} mr={2} />
                  </Button>
                  <Button cursor={'pointer'} onClick={onFilterOpen} mr={2}>
                     <IoFilterOutline size={22} />
                  </Button>
                  <Flex alignItems="center">
                     <Flex mr={2}>
                        <Popover>
                           <PopoverTrigger>
                              <IconButton
                                 icon={<Image src={Download} boxSize="24px" />}
                                 aria-label="Download Options"
                              />
                           </PopoverTrigger>
                           <PopoverContent width="220px" zIndex="10" bg={backgroundColor} mr={8}>
                              <PopoverBody p="3">
                                 <Button
                                    width="100%"
                                    variant="ghost"
                                    _hover={{ bg: 'blue.100' }}
                                    onClick={downloadExcel}
                                    justifyContent="space-between"
                                    mb={3}>
                                    <img src={xls} alt="Download XLS" width="30px" />
                                    Download Excel
                                 </Button>
                                 <Button
                                    width="100%"
                                    variant="ghost"
                                    _hover={{ bg: 'blue.100' }}
                                    onClick={downloadPDF}
                                    justifyContent="space-between">
                                    <img src={xls} alt="Download PDF" width="30px" />
                                    Download PDF
                                 </Button>
                              </PopoverBody>
                           </PopoverContent>
                        </Popover>
                     </Flex>
                  </Flex>
               </Flex>
               <Box ml={1}>
                  <Flex display={{ base: 'block', xl: 'none' }}>
                     <Button variant="unstyled" onClick={onOpen}>
                        <Image src={DotIcon} alt="Menu" width="25px" />
                     </Button>
                  </Flex>
               </Box>

               <Drawer isOpen={isOpen} placement="bottom" onClose={onClose} finalFocusRef={fromDateInputRef}>
                  <DrawerOverlay />
                  <DrawerContent borderTopRadius="20px">
                     <DrawerCloseButton />
                     <DrawerHeader borderBottomWidth="1px">Filters</DrawerHeader>
                     <DrawerBody>
                        <GridItem className="seperator-width">
                           {renderDynamicDropdown(
                              'company',
                              'Company',
                              lastcompanyOptions,
                              {
                                 value: companyFilter,
                                 onChange: handleCompanyChange,
                              },
                              {},
                              textColor,
                              false,
                              'Select company',
                              true,
                              undefined,
                              true,
                           )}
                        </GridItem>
                        <Box my={2} fontSize={'13px'} fontWeight={500}>
                           <label>Report Type</label>
                           <Select
                              options={reportTypeOptions}
                              value={reportTypeOptions.find((option) => option.value === reportType)}
                              onChange={(selectedOption) => {
                                 setReportType(selectedOption.value);
                                 setExpandedItems({});
                              }}
                              placeholder="Select Report Type"
                           />
                        </Box>
                        <Box alignItems={'center'} mt={3}>
                           <PeriodDatePicker
                              value={[new Date(dateRange.fromDate), new Date(dateRange.toDate)]}
                              onChange={handleDateRangeChange}
                              defaultPeriod="last7Days"
                              style={{ width: 250, marginRight: 20, borderRadius: 5, height: 35 }}
                           />
                        </Box>
                        <Button colorScheme="green" width="100%" onClick={onClose} mt={4}>
                           Apply Filters
                        </Button>
                     </DrawerBody>
                  </DrawerContent>
               </Drawer>
            </Flex>
         </Box>

         <Grid overflow="auto">
            <Card mt="15px" borderRadius="7px">
               <Box
                  overflowX="auto"
                  className="custom-scrollbar"
                  position="relative"
                  minH={{ base: '60vh', md: '65vh', xl: '70vh' }}
                  maxH={{ base: '60vh', md: '65vh', xl: '70vh' }}>
                  <Table variant="simple" color="gray.500" mb="24px" mt="12px">
                     {reportType === 'Trail Balance T Format' ? null : (
                        <Thead>
                           {reportType === 'Trail Balance Vertical' ? (
                              <Tr>
                                 <Th
                                    borderTop="1px solid"
                                    borderColor={borderColor}
                                    p="2px"
                                    py="4px"
                                    fontSize="10px"
                                    _dark={{ bg: '#080238' }}
                                    fontWeight="600"
                                    bg={'#F5F5F5'}
                                    position="sticky"
                                    top="-1"
                                    zIndex="1"
                                    color={textColor}>
                                    Account Code
                                 </Th>
                                 <Th
                                    borderTop="1px solid"
                                    borderColor={borderColor}
                                    p="2px"
                                    py="4px"
                                    fontSize="10px"
                                    _dark={{ bg: '#080238' }}
                                    fontWeight="600"
                                    bg={'#F5F5F5'}
                                    position="sticky"
                                    top="-1"
                                    zIndex="1"
                                    color={textColor}>
                                    Account
                                 </Th>
                                 <Th
                                    borderTop="1px solid"
                                    borderColor={borderColor}
                                    p="2px"
                                    py="4px"
                                    fontSize="10px"
                                    _dark={{ bg: '#080238' }}
                                    fontWeight="600"
                                    bg={'#F5F5F5'}
                                    position="sticky"
                                    top="-1"
                                    zIndex="1"
                                    color={textColor}
                                    isNumeric>
                                    Credit
                                 </Th>
                                 <Th
                                    borderTop="1px solid"
                                    borderColor={borderColor}
                                    p="2px"
                                    py="4px"
                                    fontSize="10px"
                                    _dark={{ bg: '#080238' }}
                                    fontWeight="600"
                                    bg={'#F5F5F5'}
                                    position="sticky"
                                    top="-1"
                                    zIndex="1"
                                    color={textColor}
                                    isNumeric>
                                    Debit
                                 </Th>
                              </Tr>
                           ) : (
                              table.getHeaderGroups().map((headerGroup) => (
                                 <Tr key={headerGroup.id}>
                                    {headerGroup.headers.map((header) => {
                                       if (!header.column.getIsVisible()) return null;

                                       const columnId = header.column.id;
                                       const isNumericColumn = [
                                          'OpeningAmount',
                                          'debitAmount',
                                          'creditAmount',
                                          'closingAmount',
                                       ].includes(columnId);

                                       return (
                                          <Th
                                             borderTop="1px solid"
                                             key={header.id}
                                             colSpan={header.colSpan}
                                             borderColor={borderColor}
                                             cursor="pointer"
                                             p="2px"
                                             py="4px"
                                             fontSize="10px"
                                             _dark={{ bg: '#080238' }}
                                             fontWeight="600"
                                             bg={'#F5F5F5'}
                                             position="sticky"
                                             top="-1"
                                             zIndex="1"
                                             color={textColor}
                                             isNumeric={isNumericColumn}
                                             whiteSpace="nowrap"
                                             onClick={header.column.getToggleSortingHandler()}>
                                             <Flex
                                                justifyContent={isNumericColumn ? 'flex-end' : 'space-between'}
                                                align="center"
                                                fontSize={{ sm: '10px', lg: '12px' }}
                                                color={textColor}>
                                                {flexRender(header.column.columnDef.header, header.getContext())}
                                                {{
                                                   asc: '↑',
                                                   desc: '↓',
                                                }[header.column.getIsSorted()] ?? null}
                                             </Flex>
                                          </Th>
                                       );
                                    })}
                                 </Tr>
                              ))
                           )}
                        </Thead>
                     )}

                     <Tbody>{renderReportContent()}</Tbody>
                  </Table>
               </Box>
            </Card>
         </Grid>

         {/* Column Visibility Modal */}
         <ColumnVisibilityModal />

         <StatementFilter
            isOpen={isFilterOpen}
            onClose={onFilterClose}
            companyIds={companyFilter}
            fromDate={datePartyWiseSalesRange.fromDate}
            toDate={datePartyWiseSalesRange.toDate}
            entityType="TrialBalance"
            subEntityType={reportType}
         />
      </>
   );
};

export default TrialBalance;
